import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { OdooProvider } from './context/OdooContext.js';
import App from './App.js';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <OdooProvider>
        <App />
      </OdooProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
